import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Acesso} from 'src/app/core/acesso';
import {ControlContainer, NgForm} from '@angular/forms';
import {ToastService} from 'src/app/services/toast/toast.service';
import {ColaboradorAcao} from "../../../core/colaboradores_acoes";
import {Funcionario} from "../../../core/funcionario";
import {FuncionarioService} from "../../../services/funcionario/funcionario.service";
import * as _ from "lodash";

@Component({
    selector: 'formulario-acoes-executadas-colaborador',
    templateUrl: './formulario-acoes-executadas-colaborador.component.html',
    styleUrls: ['./formulario-acoes-executadas-colaborador.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAcoesExecutadasColaboradorComponent implements OnInit {

    @Input() colaboradoresAcao: ColaboradorAcao[];
    @Input() colaboradorAcao: ColaboradorAcao;

    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private funcionarioService: FuncionarioService,) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.colaboradoresAcao.splice(this.index, 1);
        this.toastService.showSucesso("Colaborador removido com sucesso.")
    }


    onValorChangeColaborador(registro: any) {
        if (registro && registro.id) {
            const funcionarioJaCadastrado = _.find(this.colaboradoresAcao, (colaboradoresAtividade: ColaboradorAcao) => colaboradoresAtividade.funcionario?.id === registro.id);
            if (_.isEmpty(funcionarioJaCadastrado)) {
                this.funcionarioService.getById(registro.id).subscribe((funcionario: Funcionario) => {
                    this.colaboradorAcao.funcionario = funcionario;
                })
            } else {
                this.toastService.showAlerta("Funcionário já adicionado.")
                this.colaboradoresAcao.splice(this.index, 1);
                this.colaboradorAcao = new ColaboradorAcao();
                this.colaboradoresAcao.splice(this.index, 0, this.colaboradorAcao);
            }
        }
    }


}
